// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TimegridScheduleNote from './data'

export default function TimegridScheduleNoteFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TimegridScheduleNote">
      <TimegridScheduleNote {...props}>
        {children}
      </TimegridScheduleNote>
    </Flow>
  )
}
